import { TemplateRuleCondition } from '@core/entities/template/TemplateRuleCondition'
import {
  ChecklistApprovalQuestionSetType,
  IChecklistTemplateApprovalRule,
} from './IChecklistTemplateApprovalRule'
import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'

export class ChecklistTemplateApprovalRule extends Entity<IChecklistTemplateApprovalRule> {
  @Type(() => TemplateRuleCondition)
  conditions?: Array<TemplateRuleCondition>

  approvals?: Array<{ id: string }>

  questionSet?: {
    type: ChecklistApprovalQuestionSetType
    approvalId?: string
  }

  public static new(payload: unknown): ChecklistTemplateApprovalRule {
    const entity = plainToInstance(ChecklistTemplateApprovalRule, payload)
    return entity
  }
}
